import { Component, OnInit, ViewChild } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { Transactions } from "@app/_models";
import { AuthenticationService } from "@app/_services";
import { ApiBackendService } from "@app/_services/api-backend.service";
import { environment } from "src/environments/environment";
import { saveAs } from "file-saver";
import { Subject, throwError } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { ifError } from "assert";
import { NzModalService } from "ng-zorro-antd/modal";
import { TransactionFilters } from "@app/_helpers";
import { debounceTime } from "rxjs/operators";
import { ApplicationStateService } from "@app/_services/application-state.service";

@Component({
  selector: "app-mobilpay",
  templateUrl: "./mobilpay.component.html",
  styleUrls: ["./mobilpay.component.css"],
})
export class MobilpayComponent implements OnInit {
  orderId: string;
  transaction: Transactions;
  transactions: Transactions[] = [];
  initialTransactions: Transactions[] = [];
  loading = true;
  isVisibleModal = false;
  totalBalante = 0;
  transactionType: String;
  transactionId: Number;
  userId: Number;
  public mobilpayData: any = [];
  contactDetailsForm: FormGroup;
  currentUserInfo = null;
  firstDayCurrentMonth: Date;
  userRole = null;
  pageSize = 10;
  searchValue = "";
  searchNameValue = "";
  searchTipPersoana = "";
  searchNrFactura = "";
  searchDataCrearii = "";
  searchTipTranzactie = "";
  searchNotes = "";
  searchValoare = "";
  searchMesaj = "";
  visibleEmail = false;
  visibleName = false;
  totalPages = 1;
  currentPage = 1;
  totalItems = 0;
  anafTokenStatus: String;
  isSubmitAlert = false;
  isEfacturaAlertSuccess = false;
  isEfacturaAlertWarning = false;
  isEfacturaAlertError = false;
  efacturaMessage: String;
  reccurenceStatus: string = "";
  reccurenceMessage: string = "";
  isSpinningReccuring = false;
  private searchSubject: Subject<void> = new Subject<void>();
  isMobile = false;
  isSelectClicked: boolean = false;
  isPlaceholderShrinked: { [key: string]: boolean } = {};
  searchTerms: { [key: string]: string } = {};
  showEditNotes = 0;
  notes: string;

  sectoare = [
    { label: "SECTOR1", value: "SECTOR1" },
    { label: "SECTOR2", value: "SECTOR2" },
    { label: "SECTOR3", value: "SECTOR3" },
    { label: "SECTOR4", value: "SECTOR4" },
    { label: "SECTOR5", value: "SECTOR5" },
    { label: "SECTOR6", value: "SECTOR6" },
  ];

  subentities = [
    { label: "(Va rugam sa alegeti)", value: "" },
    { label: "B - București", value: "RO-B" },
    { label: "AB - Alba", value: "RO-AB" },
    { label: "AR - Arad", value: "RO-AR" },
    { label: "AG - Argeș", value: "RO-AG" },
    { label: "BC - Bacău", value: "RO-BC" },
    { label: "BH - Bihor", value: "RO-BH" },
    { label: "BN - Bistrița-Năsăud", value: "RO-BN" },
    { label: "BT - Botoșani", value: "RO-BT" },
    { label: "BR - Brăila", value: "RO-BR" },
    { label: "BV - Brașov", value: "RO-BV" },
    { label: "BZ - Buzău", value: "RO-BZ" },
    { label: "CL - Călărași", value: "RO-CL" },
    { label: "CS - Caraș-Severin", value: "RO-CS" },
    { label: "CJ - Cluj", value: "RO-CJ" },
    { label: "CT - Constanța", value: "RO-CT" },
    { label: "CV - Covasna", value: "RO-CV" },
    { label: "DB - Dâmbovița", value: "RO-DB" },
    { label: "DJ - Dolj", value: "RO-DJ" },
    { label: "GL - Galați", value: "RO-GL" },
    { label: "GR - Giurgiu", value: "RO-GR" },
    { label: "GJ - Gorj", value: "RO-GJ" },
    { label: "HR - Harghita", value: "RO-HR" },
    { label: "HD - Hunedoara", value: "RO-HD" },
    { label: "IL - Ialomița", value: "RO-IL" },
    { label: "IS - Iași", value: "RO-IS" },
    { label: "IF - Ilfov", value: "RO-IF" },
    { label: "MM - Maramureș", value: "RO-MM" },
    { label: "MH - Mehedinți", value: "RO-MH" },
    { label: "MS - Mureș", value: "RO-MS" },
    { label: "NT - Neamț", value: "RO-NT" },
    { label: "OT - Olt", value: "RO-OT" },
    { label: "PH - Prahova", value: "RO-PH" },
    { label: "SJ - Sălaj", value: "RO-SJ" },
    { label: "SM - Satu Mare", value: "RO-SM" },
    { label: "SB - Sibiu", value: "RO-SB" },
    { label: "SV - Suceava", value: "RO-SV" },
    { label: "TR - Teleorman", value: "RO-TR" },
    { label: "TM - Timiș", value: "RO-TM" },
    { label: "TL - Tulcea", value: "RO-TL" },
    { label: "VS - Vaslui", value: "RO-VS" },
    { label: "VL - Vâlcea", value: "RO-VL" },
    { label: "VN - Vrancea", value: "RO-VN" },
  ];
  radioTipPersoana = "Juridica";
  currentUser = JSON.parse(localStorage.getItem("currentUser"));

  @ViewChild("form") form;
  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute, private router: Router, public apiBackendService: ApiBackendService, private httpClient: HttpClient, private authenticationService: AuthenticationService, private modalService: NzModalService, private applicationStateService: ApplicationStateService) {
    this.searchSubject.pipe(debounceTime(500)).subscribe(() => {
      this.loadTransactions();
    });
    if (applicationStateService.getIsMobileResolution()) {
      this.isMobile = true;
    }
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.userRole = this.authenticationService.currentUserInfo.role;

    this.apiBackendService
      .getUserReccurence(this.currentUser.id)
      .pipe()
      .subscribe((res: any) => {
        this.reccurenceStatus = res.body.status;
        this.reccurenceMessage = res.body.message;
        this.isSpinningReccuring = true;
      });

    const date = new Date();
    this.firstDayCurrentMonth = new Date(date.getFullYear(), date.getMonth() - 1, 1);

    this.contactDetailsForm = this.formBuilder.group({
      firstName: [],
      lastName: [],
      companyName: [""],
      cui: [""],
      cnp: [""],
      regCom: [""],
      bankAccount: [],
      address: [],
      city: ["", Validators.required],
      country_subentity: ["", Validators.required],
      tip_persoana: [],
      adresses: [],
    });

    // this.currentUserInfo = JSON.parse(localStorage.getItem("currentUser"));
    // this.contactDetailsForm.patchValue({
    //   firstName: this.currentUserInfo.firstname,
    //   lastName: this.currentUserInfo.lastname,
    // });

    this.route.queryParams.subscribe((params) => {
      this.orderId = params.orderId ? params.orderId : params.order_id;
      if (this.orderId != undefined) {
        console.log(this.orderId);
        this.apiBackendService
          .getTransactionByOrderId(this.orderId)
          .pipe()
          .subscribe((res) => {
            console.log(res.body);
            this.transaction = res.body;
            setTimeout(() => {
              this.router.navigate(["/thank-you"], {
                queryParams: { order_id: this.orderId, order_value: this.transaction?.amount || 0 },
              });
            }, 5000);
          });
      }
    });
    this.checkAnafTokenStatus();
    this.loadTransactions();
  }

  loadTransactions(): void {
    this.loading = true;
    const filters: TransactionFilters = {};

    const filterValues = {
      email: this.searchValue,
      name: this.searchNameValue,
      tip_persoana: this.searchTipPersoana,
      nr_factura: this.searchNrFactura,
      data_crearii: this.searchDataCrearii,
      tip_tranzactie: this.searchTipTranzactie,
      valoare: this.searchValoare,
      mesaj: this.searchMesaj,
      notes: this.searchNotes,
    };

    for (const [key, value] of Object.entries(filterValues)) {
      if (value) {
        filters[key] = value;
      }
    }

    this.apiBackendService.getTransactionsPaginated(this.pageSize, this.currentPage, filters).subscribe((response: any) => {
      this.loading = false;
      this.totalItems = response.total_items;

      const transactions = response.results
        .map((o) => {
          const dc = new Date(o.dateCreated);
          const currentDate = new Date();
          const dc_plus5 = this.addDays(dc, 4);

          o.currentMonth = dc < dc_plus5 && dc_plus5 > currentDate;

          return {
            ...o,
          };
        })
        .filter((o) => o.errorType !== 999 || o.errorType !== "999");

      this.totalBalante = transactions.reduce((sum, tr) => sum + tr.balanceAmount, 0);
      this.transactions = transactions;
      this.initialTransactions = transactions;
    });
  }

  onPageChange(page: number) {
    this.loading = true;
    this.currentPage = page;
    this.loadTransactions();
  }

  onPageSizeChange(size: number) {
    this.loading = true;
    this.pageSize = size;
    this.currentPage = 1;
    this.loadTransactions();
  }

  addDays(date, days) {
    let result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  transactionTypeChanged() {
    console.log("tranzaction changed", this.transactionType);
    this.apiBackendService
      .getMobilPayData(this.transactionType)
      .pipe()
      .subscribe((res: any) => {
        this.mobilpayData = res.body;
        setTimeout(() => {
          this.form.nativeElement.submit();
        });
        // this.payLoading = false;
        // this.isVisibleModal = true;
        // console.log(this.mobilpayData);
      });
  }

  showInvoiceModal(id) {
    this.transactionId = id;
    console.log("transaction id ", id);
    this.isVisibleModal = true;
    this.apiBackendService.getTransactionByOrderId(id).subscribe((res: any) => {
      console.log(res.body);

      this.userId = res.body.data.userId;
      this.contactDetailsForm.patchValue({
        tip_persoana: res.body.data.user_details[0]?.tipPersoana || "Fizica",
        companyName: res.body.data.user_details[0]?.companyName,
        cui: res.body.data.user_details[0]?.cui,
        cnp: res.body.data.user_details[0]?.cui || "0000000000000",
        regCom: res.body.data.user_details[0]?.regCom,
        bankAccount: res.body.data.user_details[0]?.bankAccount,
        firstName: res.body.data.userFirstName,
        lastName: res.body.data.userLastName,
        address: res.body.data.user_details[0]?.address,
        city: res.body.data.user_details[0]?.city || "SECTOR1",
        country_subentity: res.body.data.user_details[0]?.country || "RO-B",
      });
    });
  }

  handleOk(): void {
    this.isVisibleModal = false;

    const invoice = new Object();
    invoice["transactionId"] = this.transactionId;
    invoice["firstName"] = this.contactDetailsForm.value.firstName;
    invoice["lastName"] = this.contactDetailsForm.value.lastName;
    invoice["companyName"] = this.contactDetailsForm.value.companyName;
    invoice["cui"] = this.contactDetailsForm.value.tip_persoana == "Fizica" ? this.contactDetailsForm.value.cnp : this.contactDetailsForm.value.cui;
    invoice["regCom"] = this.contactDetailsForm.value.regCom;
    invoice["bankAccount"] = this.contactDetailsForm.value.bankAccount;
    invoice["address"] = this.contactDetailsForm.value.address;
    invoice["city"] = this.contactDetailsForm.value.city;
    invoice["country_subentity"] = this.contactDetailsForm.value.country_subentity;
    invoice["tip_persoana"] = this.contactDetailsForm.value.tip_persoana;
    invoice["user_transaction_id"] = this.userId;

    console.log("inv", invoice);
    this.apiBackendService
      .updateInvoice(invoice)
      .pipe()
      .subscribe((res) => {
        // window.open(
        //   `${environment.api_backend.url}/pdf_invoice/` + res.body['invoice'],
        //   '_blank'
        // );
        // this.downloadInvoice(res.body['invoice']);
      });
  }

  handleCancel(): void {
    this.isVisibleModal = false;
  }

  downloadInvoice(id) {
    console.log("download invoice", id);
    const url = `${environment.api_backend.url}/pdf_invoice/` + id;
    //window.open(url, '_blank');

    var mediaType = "application/pdf";
    this.httpClient.get(url, { responseType: "blob" }).subscribe(
      (response) => {
        console.log(response);
        var blob = new Blob([response], { type: mediaType });
        saveAs(response, "factura-" + id + ".pdf");
      },
      (e) => {
        throwError(e);
      }
    );
  }

  checkAnafTokenStatus() {
    this.apiBackendService.getAnafTokenStatus().subscribe((response: any) => {
      this.anafTokenStatus = response.body.message;
    });
  }

  sendEfactura(id) {
    window.scrollTo(0, 0);
    this.isSubmitAlert = true;
    this.apiBackendService
      .generareEfactura(id)
      .pipe()
      .subscribe(
        (res: any) => {
          this.efacturaMessage = res.body.message;
          if (res.body.message.includes("Starea facturii: ok")) {
            this.isSubmitAlert = false;
            this.isEfacturaAlertSuccess = true;
          } else {
            this.isSubmitAlert = false;
            this.isEfacturaAlertWarning = true;
          }
          this.loadTransactions();
        },
        (error: any) => {
          this.isSubmitAlert = false;
          this.isEfacturaAlertError = true;
          this.efacturaMessage = error + ". Datele facturii/clientului nu sunt corecte";
          this.loadTransactions();
        }
      );
  }

  generareAnafToken() {
    this.apiBackendService
      .generareToken()
      .pipe()
      .subscribe((res: any) => {
        const tokenUrl = res.body.url;
        window.open(tokenUrl, "_blank");
      });
  }

  refreshAnafToken() {
    this.apiBackendService
      .refreshToken()
      .pipe()
      .subscribe((res) => {
        // console.log(res);
        this.modalService.success({
          nzTitle: "Success",
          nzContent: "Tokenul ANAF a fost reinoit cu success!",
        });
      });
  }

  reset(): void {
    this.searchValue = "";
    this.searchNameValue = "";
    this.search();
    this.transactions = this.initialTransactions;
    this.loadTransactions();
  }

  search(): void {
    this.visibleEmail = false;
    this.visibleName = false;
    // this.transactions = this.transactions.filter((item) => item["userEmail"].indexOf(this.searchValue) !== -1);
    this.searchSubject.next();
  }

  isFormValid() {
    return this.contactDetailsForm.valid;
  }

  cancelRecurrence(): void {
    this.modalService.confirm({
      nzTitle: "Ești sigur că vrei să anulezi abonamentul lunar?",
      nzContent: "Acțiunea nu poate fi reversibilă. Confirmi?",
      nzOkText: "Da",
      nzCancelText: "Nu",
      nzOnOk: () => this.cancelRecurrenceConfirm(),
    });
  }

  cancelRecurrenceConfirm(): void {
    this.apiBackendService.cancelUserReccurence(this.currentUser.id).subscribe((res: any) => {
      this.reccurenceConfirmMsg(res.body.message);
    });
    this.apiBackendService
      .getUserReccurence(this.currentUser.id)
      .pipe()
      .subscribe((res: any) => {
        this.reccurenceStatus = res.body.status;
        this.reccurenceMessage = res.body.message;
        this.isSpinningReccuring = true;
        window.location.reload();
      });
  }

  reccurenceConfirmMsg(message: string): void {
    this.modalService.confirm({
      nzTitle: "Anulare abonament lunar",
      nzContent: message,
      nzCancelText: "Inchide",
    });
  }

  clearSearch(property: keyof this): void {
    (this[property] as unknown as string) = "";
    this.search();
  }

  handleFocus(event: FocusEvent): void {
    const target = event.target as HTMLInputElement;
    const label = target.nextElementSibling;
    if (label) {
      label.classList.add("shrink");
    }
  }

  handleBlur(event: FocusEvent): void {
    const target = event.target as HTMLInputElement;
    if (!target.value) {
      const label = target.nextElementSibling;
      if (label) {
        label.classList.remove("shrink");
      }
    }
  }

  ngAfterViewInit(): void {
    document.addEventListener("click", this.handleDocumentClick.bind(this));
  }
  ngOnDestroy(): void {
    document.removeEventListener("click", this.handleDocumentClick.bind(this));
  }
  handleContainerClick(field: string): void {
    this.isPlaceholderShrinked[field] = true;
  }
  handleSelectFocus(field: string): void {
    this.isPlaceholderShrinked[field] = true;
  }
  handleSelectBlur(field: string): void {
    const formControl = this.contactDetailsForm.get(field);
    if (formControl && !formControl.value && !this.searchTerms[field]) {
      this.isPlaceholderShrinked[field] = false;
    }
  }
  handleModelChange(value: string, field: string): void {
    this.searchTerms[field] = value;
    this.isPlaceholderShrinked[field] = !!value;
  }
  handleDocumentClick(event: MouseEvent): void {
    const containers = document.querySelectorAll(".custom-select-container");
    containers.forEach((container) => {
      const field = container.getAttribute("data-field");
      if (!container.contains(event.target as Node)) {
        const formControl = this.contactDetailsForm.get(field);
        if (formControl && !formControl.value && !this.searchTerms[field]) {
          this.isPlaceholderShrinked[field] = false;
        }
      }
    });
  }

  get tipPersoana() {
    return this.contactDetailsForm.value.tip_persoana;
  }
  toggleShowEditNotes(entryId) {
    this.showEditNotes = entryId;
    const index = this.transactions.findIndex((m) => m.id.toString() === entryId.toString());
    this.notes = this.transactions[index].notes;
  }

  saveNotes(id: number) {
    const index = this.transactions.findIndex((m) => m.id.toString() === id.toString());
    console.log("index", index);
    console.log("mob", this.transactions);
    this.transactions[index].notes = this.notes;

    this.showEditNotes = 0;
    let note = new Object();
    note["notes"] = this.notes;
    this.apiBackendService
      .updateInvoiceNotes(this.transactions[index].invoice, note)
      .pipe()
      .subscribe((res) => { });
  }
}
